import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type RfqLineCreateParams = {
  quantity: number
  item: string
  supplier_part_number: string
  manufacturer_id: string
  rfq_id: number
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqLineCreateMutation = () =>
  useMutation<any, ErrorDTO, RfqLineCreateParams>({
    mutationFn: async (params: RfqLineCreateParams) => {
      try {
        const res = await client.post('/rfq/line/create', params)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
